"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = exports.PRODUCT_IMAGE_SIZE = exports.ImageRoot = exports.BundleImages = exports.BundleImage = exports.BUNDLE_IMAGE_SIZE = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const BUNDLE_IMAGE_SIZE = exports.BUNDLE_IMAGE_SIZE = 70;
const BUNDLE_TWO_IMAGES_OVERLAP = -10;
const BUNDLE_THREE_IMAGES_OVERLAP = -40;
const PRODUCT_IMAGE_SIZE = exports.PRODUCT_IMAGE_SIZE = 80;
const ImageRoot = exports.ImageRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignContent: 'center',
  borderRadius: '10px',
  height: 140,
  backgroundColor: theme.palette.grey[100],
  overflow: 'hidden',
  position: 'relative',
  maxWidth: PRODUCT_IMAGE_SIZE,
  width: '100%'
}));
const BundleImage = exports.BundleImage = (0, _mui.styled)('img')(({
  theme
}) => ({
  aspectRatio: '1/1',
  border: `1px solid ${theme.palette.grey[800]}`,
  borderRadius: '50%',
  display: 'block',
  height: BUNDLE_IMAGE_SIZE,
  position: 'relative',
  width: BUNDLE_IMAGE_SIZE
}));
const BundleImages = exports.BundleImages = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  imagesCount
}) => ({
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  position: 'relative',
  top: (imagesCount === 2 ? BUNDLE_TWO_IMAGES_OVERLAP : BUNDLE_THREE_IMAGES_OVERLAP) / 2,
  width: '100%',
  img: {
    marginBottom: imagesCount === 2 ? BUNDLE_TWO_IMAGES_OVERLAP : BUNDLE_THREE_IMAGES_OVERLAP
  }
}));
const Svg = exports.Svg = (0, _mui.styled)('svg')({
  maxHeight: '100%',
  maxWidth: '100%'
});
